import { render } from "./TagForm.vue?vue&type=template&id=4676a470"
import script from "./js/tagForm.js?vue&type=script&lang=js&external"
export * from "./js/tagForm.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__